import type { IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { Option } from 'src/types';
import type { PrebidVersion } from '../../types';

export enum TagsListSearchKey {
  SEARCH_QUERY = 'searchQuery',
}

export type TagsListFiltersState = {
  searchQuery: string;
  includeInactive: boolean;
  prebidVersion: Option<PrebidVersion> | null;
};

export interface TagsListRouteParams {
  integrationType: IntegrationType;
}
